<template>
  <div class="fullview" @click="tapBg()">
    <button @click.stop="setCol(1)">1列</button>
    <button @click.stop="setCol(3)">3列</button>
    <button @click.stop="setCol(5)">5列</button>

    <div class="scroll">
      <div class="item" v-for="(item, index) in this.designImageList" v-bind:key="index">
        {{index+1}} / {{$store.state.currentProduct.quantity}}
        <img :src="item" style="width:500px;" class=""/>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: "ListPreview",
  data: function () {
    return {
      designImageList:[],
      col:1,
    };
  },
  components: {
  },
  async created() {
    this.designImageList = Array.from({ length: this.$store.state.currentProduct.quantity }, () => "");
    for( let i=0; i<this.$store.state.currentProduct.quantity; ++i ){
      let blob = await this.$store.state.currentCanvasData.createAcrylImageBlob(i);
      Vue.set(this.designImageList, i, URL.createObjectURL(blob.designImage));
    }
  },
  methods: {
    setCol(num){
      this.col = num;
    },
    tapBg(){
      // 編集アイテムの表示を戻す
      if (this.$store.state.currentCanvasData) {
        for (const item of this.$store.state.currentCanvasData.itemList.slice()) {
          item.updateImage(this.$store.state.currentSelectPlateNo);
        }
      }
      this.$store.commit("hideListPreview");
    }
  }

};
</script>

<style scoped>
.fullview {
  width: 100%;
  height: 100%;
  background: #000000aa;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.scroll {
  overflow-y: scroll;
}

.item {
  border: 2px solid #000000;
}

</style>
